/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @next/next/no-img-element */
/* eslint-disable react/no-unescaped-entities */
// @ts-nocheck
import { useContext, useEffect, useState } from 'react'
import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'
import InputForm from '@/components/atoms/input/InputForm'
import * as yup from "yup";
import { handleChangeField, handleChangeSelect } from '@/utility/helper/dataMutation';
import InputSearch from '@/components/atoms/input/inputSearch';
import { icon_list } from '@/assets/images';
import Image from 'next/image';
import { StyledButton } from '@/components';
import usePressQuery from '@/utility/hooks/apiHooks/usePress';
import route_list from '@/constant/routeUrl';
import { PageLoading, GeneralEmptyData, MetaData } from '@/components/atoms';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { getSeoMetadata } from '@/utility/apiProcess/seo/server';
import DataHandlerContext from '@/utility/context/dataHandler';

export async function getStaticProps() {
  const locale = 'id'
  let seoMetadata = { data: { result: {} } }
  try {
    seoMetadata = await getSeoMetadata({category_slug: 'pages', names: 'press'})
  } catch (err) {
    console.error('[getStaticProps] getSeoMetadata failed at build time, falling back to {}', err)
  }

	return {
		props: {
      seoMetadata: seoMetadata.data.result || {},
			...(await serverSideTranslations(locale, ['footer', 'navbar', 'press'])),
		},
	}
}

const Press = (props) => {
	const { t } = useTranslation('press')
  const [timer, setTimer] = useState<NodeJS.Timeout | number>(0)
	const router = useRouter()
	const [formToState, setFormToState] = useState([
    {
      title: "",
      placeholder: 'Choose Status',
      type: 'select',
      value: '',
      name: 'keterangan',
      rules: yup.object().required("Influencer is required!").nullable(),
      error: '',
      options: [
        { value: 'Evaluasi', label: 'Evaluasi' },
        { value: 'Evaluasi 2', label: 'Evaluasi 2' },
        { value: 'Evaluasi 3', label: 'Evaluasi 3' }
      ],
    },
		{
      title: "",
      placeholder: 'Choose Status',
      type: 'select',
      value: '',
      name: 'keterangan2',
      rules: yup.object().required("Influencer is required!").nullable(),
      error: '',
      options: [
        { value: 'Evaluasi', label: 'Evaluasi' },
        { value: 'Evaluasi 2', label: 'Evaluasi 2' },
        { value: 'Evaluasi 3', label: 'Evaluasi 3' }
      ],
    },
		{
      title: "",
      placeholder: 'Search Press',
      type: 'search',
      value: '',
      name: 'search',
      rules: yup.object().required("Influencer is required!").nullable(),
      error: '',
    },
  ])
	const {pressList, startPressList, pressPageInfo, setIsSearch, loadingPressList} = usePressQuery()
  const {language, token, role, dataUser, dispatch}:any = useContext(DataHandlerContext)

	const handleOnChange = (event:any, targetMutation:any, setTargetMutation:any) => {
    let clone_filter = _.cloneDeep(formToState)
    const targetType = event.target.type
    if(targetType === 'search') {
      clone_filter = handleChangeField(event, targetMutation)
    } 
    setTargetMutation(clone_filter)
    
    clearTimeout(timer)
    const new_time = setTimeout(() => {
      handleFilter(clone_filter, 'filter_data')
    }, 2000)
    
    setTimer(new_time)
  }

	const handleFilter = (params:any = null, type:string) => {
    let filter_data:any = {}
		setIsSearch(true)
    // let clone_row_pagination = _.cloneDeep(rowsPagination)
    
    if(type === 'filter_data') {
      params.forEach((item:any) => {
        if(item.value) {
          if(_.isObject(item.value) && !_.isDate(item.value)) {
            filter_data[item.name] = item.value.value
          } else if(_.isDate(item.value)) {
            filter_data[item.name] = dayjs(item.value).format('YYYY-MM-DD')
          } else {
            filter_data[item.name] = item.value
          }
        }
      })

      filter_data = _.merge(filter_data)
    } else if(type === 'pagination') {
      _.cloneDeep(filterSearch).forEach((item:any) => {
        if(item.value) {
          filter_data[item.name] = item.value
        }
      })
      filter_data = _.merge(filter_data, params)
    } else {
      let clone_filter = _.cloneDeep(filterSearch)
      clone_filter = clone_filter.map((item:any) => {
        return {
          ...item,
          value: ''
        }
      })
      setFilterSearch(clone_filter)
    }

		startPressList({page:1, limit: 999, order: 'desc', ...filter_data})
  }

	useEffect(() => {
    if(!_.isEmpty(language)) {
			setIsSearch(false)
			startPressList({page:1, limit: 10, order: 'desc', lang: language})
    }
  }, [language])
	
	if(loadingPressList) {
		return <PageLoading />
	}

	// console.log(pressList)
	
	return (
		<div className='tw-bg-gradient-to-r tw-from-dark-green tw-to-light-green tw-w-full'>
      <MetaData title={props.seoMetadata.title} ogImage="https://i.ibb.co/bzC5z1g/socialbreadlogo.jpg" ogTitle={props.seoMetadata.title} keywords={props.seoMetadata.keywords} ogDescription={props.seoMetadata.description} />
			<div className='tw-newsroom-banner' id='newsroom-banner'>
				<div className='tw-m-auto md:tw-py-16 tw-py-8 tw-px-4 tw-max-w-6xl tw-mx-auto'>
					<h2 className='tw-text-white md:tw-text-5xl tw-text-2xl tw-font-bold tw-mb-5'>
						{t('press.title')}
					</h2>
					<span className='tw-text-white tw-text-sm tw-text-justify tw-flex'>
						{t('press.desc')}
					</span>
				</div>
			</div>
			<div className='tw-w-full tw-min-h-[500px] tw-flex tw-items-center tw-justify-center tw-flex-col tw-bg-[#F1F1F1] md:tw-rounded-[40px] tw-rounded-[20px]'>
				<div className='tw-newsroom-container'>
					{pressList.length !== 0 ? (
						<div className='tw-max-w-6xl tw-mx-auto tw-my-8 md:px-0 tw-text-justify tw-px-4'>
							<h1 className='md:tw-text-6xl tw-text-2xl tw-font-bold tw-mb-10 tw-text-transparent tw-bg-clip-text tw-bg-gradient-to-r tw-from-dark-green tw-to-light-green'>News & Press Releases</h1>
							<div className='tw-flex md:tw-flex-row tw-flex-col-reverse tw-mb-10 tw-gap-4'>
								<div className='tw-grid tw-w-full'>
									{/* <InputForm 
										formData={formToState.slice(0, 2)}
										onChange={handleOnChange}
										targetMutation={formToState}
										setTargetMutation={setFormToState}
										containerStyle='tw-grid md:tw-grid-cols-2 tw-grid-cols tw-gap-4 md:tw-w-[400px]'
									/> */}
								</div>
								<div className='tw-flex tw-justify-end md:tw-w-[500px] md:mt-0'>
									<InputSearch value={formToState[2].value} name={formToState[2].name}  placeholder={formToState[2].placeholder} onChange={e => handleOnChange(e, formToState, setFormToState)}/>
								</div>
							</div>
							{pressList.map((item,index) => {
								return (
									<button onClick={() => router.push(route_list.pressDetail(item.id))} key={`press-card=${index}`} className="tw-w-full tw-mb-6 tw-flex md:tw-flex-wrap tw-flex-wrap-reverse tw-bg-white tw-p-4 tw-rounded-xl">
										<div className="tw-mb-0 tw-ml-auto tw-w-full tw-shrink-0 tw-grow-0 tw-basis-auto tw-px-3 md:tw-w-3/12">
											<div className="tw-relative tw-overflow-hidden tw-rounded-lg tw-bg-cover tw-bg-no-repeat tw-shadow-lg tw-shadow-black/20 tw-h-[150px]" data-te-ripple-init data-te-ripple-color="light">
												<div className='tw-w-[250px] tw-h-[150px]'>
													<img src={item.img} className="tw-w-full tw-h-full tw-object-cover" alt="Louvre" />
												</div>
												<a href="#!">
													<div className="tw-absolute tw-top-0 tw-right-0 tw-bottom-0 tw-left-0 tw-h-full tw-w-full tw-overflow-hidden tw-bg-fixed tw-opacity-0 tw-transition tw-duration-300 tw-ease-in-out tw-hover:tw-opacity-100 tw-bg-[hsla(0,0%,98.4%,.15)]">
													</div>
												</a>
											</div>
										</div>

										<div className="tw-mb-6 tw-mr-auto tw-w-full tw-shrink-0 tw-grow-0 tw-basis-auto tw-px-3 md:tw-mb-0 md:tw-w-9/12 tw-xl:w-7/12">
												<div className='tw-flex tw-flex-row tw-gap-3'>
													<p className="tw-text-dark-green tw-font-semibold tw-text-left">
														<small>{item.date}</small>
													</p>
													<div className="tw-mb-3 tw-flex tw-gap-2 tw-items-center tw-font-medium tw-text-danger tw-justify-start">
														<div className='tw-bg-gray-200 tw-px-2 tw-py-1 tw-text-dark-green tw-text-xs'>{item.type}</div>
														{/* <div className='tw-bg-gray-200 tw-px-2 tw-py-1 tw-text-dark-green tw-text-xs'>Economy</div> */}
													</div>
												</div>
												<h5 className="tw-mb-3 tw-text-xl tw-font-bold tw-text-transparent tw-bg-clip-text tw-bg-gradient-to-r tw-from-dark-green tw-to-light-green tw-text-left">{item.title}</h5>
											<div className='tw-flex tw-flex-row tw-justify-between tw-gap-8'>
												<p className="tw-text-neutral-500 tw-text-left">
													{item.descriptiom}
												</p>
												<Image src={icon_list.next_gradient_green} alt="" />
											</div>
										</div>
									</button>
								)
							})}
						</div>
					) : (<GeneralEmptyData/>)}
					
				</div>
				{(pressPageInfo.totalPage > 1 && Number(pressPageInfo.currentPage) !== pressPageInfo.totalPage) && (
					<div className='tw-flex md:tw-flex-row tw-flex-col tw-justify-center tw-mt-4 tw-gap-5 tw-mb-20'>
						<StyledButton
							title={'Load More'}
							className='tw-text-dark-green tw-font-semibold md:tw-text-lg tw-text-md tw-items-center tw-px-5 md:tw-py-2 tw-py-3 tw-rounded-full tw-border-dark-green tw-border md:tw-flex md:tw-w-[200px] tw-justify-center'
							onClick={() => {
								setIsSearch(true)
								startPressList({page:Number(pressPageInfo.currentPage) + 1, limit: 10, order: 'desc'})
							}}
						/>
					</div>
				)}
			</div>
		</div>
	)
}

export default Press

 